import * as React from "react";
import {
  Box,
  Button,
  Stack,
  Typography,
} from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";


export default function Welcome(props: { handlePageChange: (page: string) => void }) {
  const { handlePageChange } = props;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        bgcolor: "#08050b",
        color: "#FFFFFF",
        backgroundImage:
          "linear-gradient(90deg, rgba(9,5,11,0.95) 0%, rgba(9,5,11,0.8) 40%, rgba(46,16,84,0.3) 72%, rgba(46,16,84,0.12) 100%), linear-gradient(180deg, rgba(8,5,11,0.1) 0%, rgba(8,5,11,0.35) 55%, #08050b 100%), url('/background.png')",
        backgroundSize: "cover",
        backgroundPosition: { xs: "62% center", md: "center" },
        px: { xs: 2.5, sm: 4, md: 6 },
        py: { xs: 2.5, md: 4 },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at 18% 12%, rgba(168,85,247,0.22), transparent 40%), radial-gradient(circle at 82% 78%, rgba(56,189,248,0.12), transparent 42%)",
          pointerEvents: "none",
        }}
      />

      <Stack
        sx={{
          position: "relative",
          zIndex: 1,
          flex: 1,
          width: "100%",
          maxWidth: 1180,
          mx: "auto",
        }}
      >
        <Box
          component="img"
          src="/logo.png"
          alt="Stellaris"
          sx={{
            width: 42,
            height: 42,
            objectFit: "contain",
            borderRadius: 2,
            bgcolor: "rgba(255,255,255,0.92)",
            p: 0.55,
          }}
        />

        <Stack
          spacing={{ xs: 3, md: 3.5 }}
          justifyContent="center"
          alignItems="flex-start"
          sx={{ flex: 1, width: "100%", maxWidth: 640, py: { xs: 6, md: 8 } }}
        >
          <Typography
            component="h1"
            sx={{
              m: 0,
              color: "#FFFFFF",
              fontWeight: 900,
              fontSize: { xs: 40, sm: 54, md: 66 },
              lineHeight: 1.04,
              textShadow: "0 0 40px rgba(168,85,247,0.35)",
            }}
          >
            Stellaris
            <Box component="span" sx={{ display: "block", color: "#C4B5FD" }}>
              Mission Control
            </Box>
          </Typography>

          <Typography
            sx={{
              color: "rgba(226,232,240,0.82)",
              fontSize: { xs: 16, md: 19 },
              lineHeight: 1.6,
              maxWidth: 540,
            }}
          >
            powered by Stellaris Space Adventures
          </Typography>

          <Button
            variant="contained"
            endIcon={<ArrowForwardRoundedIcon />}
            onClick={() => handlePageChange("Entry")}
            sx={{
              alignSelf: { xs: "stretch", sm: "flex-start" },
              px: 3.5,
              py: 1.35,
              fontSize: 15,
              borderRadius: 2,
              bgcolor: "#7C3AED",
              color: "#FFFFFF",
              fontWeight: 800,
              textTransform: "none",
              boxShadow: "0 16px 34px rgba(124,58,237,0.35)",
              "&:hover": {
                bgcolor: "#6D28D9",
                boxShadow: "0 18px 38px rgba(124,58,237,0.45)",
              },
            }}
          >
            Enter Mission Control
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
